import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import moment from 'moment';
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {QuestionnaireService} from "../../../../services/questionnaire/questionnaire.service";

@Component({
  selector: 'app-selected-questionnaire',
  templateUrl: './selected-questionnaire.component.pug',
  styleUrls: ['./selected-questionnaire.component.scss'],
  standalone: false
})
export class SelectedQuestionnaireComponent implements OnInit, OnChanges {
  @Input() selectedQuestionnaire: any;
  @Input() showDeleteButton?: boolean; // Allow parent to control delete button visibility (undefined = use default logic)
  @Output() deleted = new EventEmitter();
  @Output() questionnaire = new EventEmitter();

  // feature flag
  ent_10605_request_templates = false;
  isReferenceSurvey = false;

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.ent_10605_request_templates = this.permissions.isFeatureActivated('ent-10605-request-templates');
    this.isReferenceSurvey = this.selectedQuestionnaire?.survey_type === QuestionnaireService.survey_type_mapping.reference.toString();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setFormattedDate(this.selectedQuestionnaire);
    this.questionnaire.emit(this.selectedQuestionnaire);
  }

  deleteQuestionnaireSelection() {
    this.deleted.emit('true')
  }

  setFormattedDate(selectedQuestionnaire){
    if(selectedQuestionnaire['last_used']){
      selectedQuestionnaire['last_used_formatted'] = moment(selectedQuestionnaire['last_used']).format('ll');
    }
    if(selectedQuestionnaire['modified']){
      selectedQuestionnaire['modified_formatted'] = moment(selectedQuestionnaire['modified']).format('ll');
    }
  }

}
